import List from './list/IncidentReportStatusListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})